import { render, staticRenderFns } from "./BaseFormView.vue?vue&type=template&id=33380560&scoped=true"
import script from "./BaseFormView.vue?vue&type=script&lang=js"
export * from "./BaseFormView.vue?vue&type=script&lang=js"
import style0 from "./BaseFormView.vue?vue&type=style&index=0&id=33380560&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33380560",
  null
  
)

export default component.exports